import { render, staticRenderFns } from "./LowStateTypeDashboard.vue?vue&type=template&id=4a528af3&scoped=true"
import script from "./LowStateTypeDashboard.vue?vue&type=script&lang=js"
export * from "./LowStateTypeDashboard.vue?vue&type=script&lang=js"
import style0 from "./LowStateTypeDashboard.vue?vue&type=style&index=0&id=4a528af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a528af3",
  null
  
)

export default component.exports